import {StepProps} from '../../../../../app/modules/project/components/core/_models'
import {useEffect} from 'react'

const idIncluded = (ids: number[] | undefined, taskId: number) =>
  (ids ?? []).some((id) => Number(id) === Number(taskId))

export const TaskTemplatesStep = ({
  data,
  updateData,
  taskTemplates = [],
}: StepProps & {taskTemplates: any[]}) => {
  useEffect(() => {
    const ids = taskTemplates.map((taskTemplate) => taskTemplate.id)
    updateData({task_template_ids: ids})
  }, [taskTemplates, updateData])
  
  return (
    <div className='pb-5'>
      <div className='w-100'>
        <label className='d-flex align-items-center fs-5 fw-semibold mb-4'>
          Modelos de tarefas
        </label>

        <table className='table table-row-bordered table-row-gray-200 align-middle gs-0 gy-3'>
          <thead>
            <tr className='fw-bold text-muted'>
              <th className=''>
                {' '}
                <div className='form-check form-check-custom form-check-sm'>
                  <input
                    role='button'
                    className='form-check-input'
                    type='checkbox'
                    checked={taskTemplates.every((taskTemplate) =>
                      idIncluded(data.task_template_ids, taskTemplate.id)
                    )}
                    onChange={(e) => {
                      const updatedIds = e.target.checked
                        ? taskTemplates.map((taskTemplate) => taskTemplate.id)
                        : []

                      updateData({task_template_ids: updatedIds})
                    }}
                  />
                </div>
              </th>
              <th>Tarefas</th>
            </tr>
          </thead>
          <tbody>
            {taskTemplates.map((taskTemplate) => (
              <tr key={taskTemplate.id}>
                <td>
                  <div className='form-check form-check-custom form-check-sm'>
                    <input
                      role='button'
                      className='form-check-input'
                      type='checkbox'
                      checked={idIncluded(data.task_template_ids, taskTemplate.id)}
                      onChange={(e) => {
                        const updatedIds = idIncluded(
                          data.task_template_ids,
                          taskTemplate.id
                        )
                          ? (data.task_template_ids || []).filter(
                              (id) => Number(id) !== Number(taskTemplate.id)
                            )
                          : [...(data.task_template_ids || []), taskTemplate.id]

                        updateData({task_template_ids: updatedIds})
                      }}
                    />
                  </div>
                </td>
                <td>
                  {taskTemplate.name}
                  {taskTemplate.parent_id ? (
                    <span className='badge badge-light-info ms-2'>Subtarefa</span>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
